export const SectionHeading = ({ eyebrow, title, description, id }) => (
  <div>
    <p className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
      {eyebrow}
    </p>
    <h2 id={id} className="mt-2 text-lg font-semibold text-slate-950">
      {title}
    </h2>
    {description && (
      <p className="mt-2 max-w-4xl text-sm leading-6 text-slate-600">
        {description}
      </p>
    )}
  </div>
);

export const Metric = ({ label, value, detail }) => (
  <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
    <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
      {label}
    </p>
    <p className="mt-2 text-xl font-semibold text-slate-950">{value}</p>
    {detail && <p className="mt-1 text-xs text-slate-500">{detail}</p>}
  </div>
);
